import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../../components/Layout";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import { get } from "../../../services/ApiService";
import  StatsOverview  from "./StatsOverview";
import JobSection  from "./JobSection";
import "../../custom-style.css";
import Job from "./Job";
import OrderDispatch from "../../../components/OrderDispatch";

const CourierJobs = () => {
  const canNewDesign = usePermissionCheck(["order.courier_jobs_new"]);
  const [isLoading, setIsLoading] = useState(false);
  const [runningJobs, setRunningJobs] = useState([]);
  const [completedJobs, setCompletedJobs] = useState([]);
  const [notPrintedJob, setNotPrintedJob] = useState([]);
  const [printedJob, setPrintedJob] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      fetchData();
      // setLastUpdated(new Date());
    }, 2000);
    return () => clearInterval(interval);
  }, [selectedDate]);

    const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await get(`api/orders/courier/jobs?date=${selectedDate}`);
      if (res.success) {
        // setRunningJobs(res.jobs.filter(job => job.status === "IN_PROGRESS"));
        // setCompletedJobs(res.jobs.filter(job => job.status === "COMPLETED" || job.status === "FAILED"));
        setRunningJobs(res.inProgress || []);
        setNotPrintedJob(res.notPrinted || []);
        setPrintedJob(res.printed || []);
      } else {
        console.error(res.message);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Layout>
      <div className="py-4" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0" style={{ fontWeight: "600", color: "#2c3e50" }}>
            <i className="bi bi-truck me-2"></i>Courier Job Dashboard {""}
          </h4>
          <div className="d-flex align-items-center gap-2">
            {/* <i className="bi bi-arrow-clockwise me-1"></i>
            {lastUpdated.toLocaleTimeString()}
            {isLoading && <span className="ms-2">🔄 Updating...</span>} */}
            {canNewDesign && (
              <Link className="btn btn-outline-secondary btn-sm" to="/orders/courier-jobs/new">
                New design
              </Link>
            )}
            <OrderDispatch openJobsInNewTab={false} />
            <input
              type="date"
              className="form-control form-control-sm"
              id="labelDate"
              style={{
                width: '160px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                backgroundColor: '#fff',
              }}
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>
        </div>

        <StatsOverview activeJobs={runningJobs} notPrintedJob={notPrintedJob} printedJob={printedJob}  />

        <JobSection
          jobs={runningJobs}
          title="Active Jobs"
          icon="bi-activity"
          color="#4CAF50"
          emptyMessage="No active jobs currently running"
        />

        <JobSection
          jobs={notPrintedJob}
          title="Labels Awaiting Print"
          icon="bi-clock"
          color="#fc3a3aff"
          emptyMessage="No unprinted job found for this date."
        />

        <JobSection
          jobs={printedJob}
          title="Printed Jobs"
          icon="bi-check-circle"
          color="#2196F3"
          emptyMessage="No printed job found for this date."
        />
      </div>
    </Layout>
  );
};

export default CourierJobs;